
import {catchError} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FgiBackEndService } from '../fgi-back-end.service';
import { TaxaJurosMaximaAgente } from 'src/app/model/taxa-juros-maxima-agente.model';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
  providedIn: 'root'
})
export class TaxaJurosMaximaAgenteService extends FgiBackEndService<any>{
  // @Override
  getNewEntity() {
    return undefined;
  }

  // @Override
  protected getResourceURL(): string {
    return undefined;
  }

  public remover(id: number): Observable<unknown> {
    const options: any = blockUi();
    return this.http.post('rest/front/taxa-juros-maxima-agente/' + id + "/excluir", null, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<unknown>;
  }

  public salvar(taxa: TaxaJurosMaximaAgente): Observable<TaxaJurosMaximaAgente> {
    const options: any = blockUi();
    return this.http.post('rest/front/taxa-juros-maxima-agente', taxa, options).pipe(
        catchError((e) => this.handleError(e))) as Observable<TaxaJurosMaximaAgente>;
  }

  public buscarTodos(): Observable<TaxaJurosMaximaAgente[]> {
    const options: any = blockUi();
    return this.http.get(`rest/front/taxa-juros-maxima-agente`, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<TaxaJurosMaximaAgente[]>;
  }  
}